<template>
  <div v-rect-loading="loading" class="template-container">
    <div class="template-editor-header">
      <div class="template-editor-title">{{ titleLabel }}</div>
    </div>
    <div class="container">
      <div class="name-info">
        <span class="label">
          <span>{{ $t(`${this.i18nPrefix}.label.templateName`) }}</span>
          <span class="is-required">*</span>
        </span>
        <el-input v-model="templateInfo.name"></el-input>
        <div v-if="showNameErrorTip" class="error-tip">{{ $t('common.message.requiredFormField') }}</div>
      </div>
      <div class="content-info">
        <span class="label">{{ $t(`${this.i18nPrefix}.label.contentLabel`) }}</span>
        <TinymceEditor
          v-model="templateInfo.content"
          showTemplateField
          :templateFields="templateFieldList"
          :disabled="isView"
          :currentAccountId="currentAccountId"
        ></TinymceEditor>
      </div>
      <div class="footer-group">
        <el-button class="btn cancel" @click="handleCancelTemplate">{{ $t('common.btn.cancel') }}</el-button>
        <el-button class="btn save" :disabled="isView" @click="handleSaveTemplate">{{ $t('common.btn.save') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import TinymceEditor from '../tinymceEditor.vue'
import { addI18nProperty } from '@/i18n'

export default {
  components: {
    TinymceEditor
  },
  data () {
    return {
      ...mapGetters('account', ['getCurrentAccount']),
      i18nPrefix: 'admin.company.offerLetterInviteRecordManagement',
      currentAccountId: null,
      uploaderToken: null,
      loading: false,
      showNameErrorTip: false,
      templateFieldList: [],
      templateInfo: {
        name: null,
        content: null
      }
    }
  },
  computed: {
    titleLabel () {
      if (this.isEdit) {
        return this.$t(`${this.i18nPrefix}.title.offerLetterTemplateEdit`)
      } else if (this.isView) {
        return this.$t(`${this.i18nPrefix}.title.offerLetterTemplateView`)
      }
      return this.$t(`${this.i18nPrefix}.title.offerLetterTemplateAdd`)
    },
    templateId () {
      return this.$route.params.templateId
    },
    isEdit () {
      return this.$route.meta.isEdit
    },
    isView () {
      return this.$route.meta.isView
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('common', ['getQiniuUploadToken']),
    ...mapActions('offerLetter', ['getOfferLetterTemplateFieldList', 'getOfferLetterTemplateInfoById', 'createOfferLetterTemplate', 'updateOfferLetterTemplate']),
    initPage () {
      if (this.templateId) {
        this.loadTemplateInfo()
      }
      this.currentAccountId = this.getCurrentAccount().id
      this.loadTemplateFiledList()
    },
    async loadTemplateInfo () {
      this.loading = true
      try {
        const resp = await this.getOfferLetterTemplateInfoById(this.templateId)
        if (resp) {
          this.templateInfo = resp
        }
      } finally {
        this.loading = false
      }
    },
    async loadTemplateFiledList () {
      this.loading = true
      try {
        const resp = await this.getOfferLetterTemplateFieldList({ is_enabled: 1 })
        if (resp) {
          _.forEach(resp, item => {
            addI18nProperty(item, 'i18nName', 'name_cn', 'name_en')
          })
          this.templateFieldList = resp
        }
      } finally {
        this.loading = false
      }
    },
    validateTemplate () {
      if (!this.templateInfo.name) {
        this.showNameErrorTip = true
        return false
      } else {
        this.showNameErrorTip = false
      }
      return true
    },
    async handleSaveTemplate () {
      if (!this.validateTemplate()) {
        return
      }
      this.loading = true
      try {
        if (this.isEdit) {
          await this.updateOfferLetterTemplate(this.templateInfo)
        } else {
          await this.createOfferLetterTemplate(this.templateInfo)
        }
        this.handleCancelTemplate()
      } finally {
        this.loading = false
      }
    },
    handleCancelTemplate () {
      this.$router.push('/v-admin/offer-letter-management/template')
    }
  }
}
</script>

<style lang="scss" scoped>
.template-container {
  .template-editor-header {
    display: flex;
    border-bottom: 1px solid #e4e7ed;
    .template-editor-title {
      padding-top: 4px;
      padding-bottom: 18px;
      line-height: 25px;
      font-size: 18px;
      font-weight: 500;
      color: #303133;
    }
  }
  .container {
    width: 839px;
    margin: 30px auto;
    .name-info {
      position: relative;
      display: flex;
      margin-top: 30px;
      .label {
        width: 170px;
        .is-required {
          color: #f56c6c;
          margin-left: 4px;
        }
      }
      .el-input {
        flex: 1;
      }
      .error-tip {
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        top: 100%;
        left: 170px;
      }
    }
    .content-info {
      margin-top: 30px;
      .label {
        display: block;
        margin-bottom: 10px;
      }
    }

    .footer-group {
      margin-top: 30px;
      display: flex;
      justify-content: flex-end;
      .btn {
        padding: 8px 28px;
        border-radius: 2px;
        line-height: 22px;
        font-size: 16px;
        font-weight: 500;
        color: #0096cc;
      }
      .save {
        margin-left: 24px;
        margin-right: 0;
        background: #0096cc;
        border-color: #0096cc;
        color: #fff;
      }
    }
  }
}
</style>
